import React, {Component} from 'react';
import styles from './styles.css';

export default class Field extends Component {
	render() {
		let className = styles['bsui-field'] + ' ' + (this.props.className ? this.props.className : '');

		return (
			<div className={className}>
				<label className={styles['bsui-field__text']}>{this.props.text}</label>
				<div className={styles['bsui-field__control']}>
					{this.props.children}
					{this.props.error ? (
						<div className={styles['bsui-field__error']}>{this.props.error}</div>
					) : null}
					{this.props.hint ? (
						<div className={styles['bsui-field__hint']}>{this.props.hint}</div>
					) : null}
				</div>
			</div>
		);
	}
}
